import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

export const useListingsSearchParam = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const listingsSearchParam = searchParams.get('search');

  const deleteListingsSearchParam = useCallback(() => {
    setSearchParams(previousSearchParams => {
      const updatedSearchParams = new URLSearchParams(previousSearchParams);
      updatedSearchParams.delete('search');
      return updatedSearchParams;
    });
  }, [setSearchParams]);

  const setListingsSearchParam = useCallback(
    (value: string) => {
      setSearchParams(previousSearchParams => {
        const updatedSearchParams = new URLSearchParams(previousSearchParams);
        updatedSearchParams.set('search', value);
        return updatedSearchParams;
      });
    },
    [setSearchParams],
  );

  return {
    listingsSearchParam,
    deleteListingsSearchParam,
    setListingsSearchParam,
  };
};
